module.exports = __webpack_public_path__ + "static/media/login1.f7f888ef.png";